import { PaymentTerminalFormValues } from "../PaymentTerminalForm/types";

export const initialValues: PaymentTerminalFormValues = {
  input: {
    name: "",
    stripeTerminalRegistrationCode: "",
  },
};
